import React, { FC, ReactNode, useContext, useEffect, useRef, useState } from "react";
import styles from "./Section.module.scss";
import { Loader } from "../../progress/Loader";
import { AppContext } from "../../../pages/profile/Profile";

export const Section: FC<{
  title?: string;
  subtitle?: string;
  busy?: boolean;
  children?: ReactNode;
}> = ({ title, subtitle, children, busy }) => {
  const [isStuck, setIsStuck] = useState(false);
  const titleRef = useRef<HTMLDivElement>(null);
  const { scrollY } = useContext(AppContext);

  useEffect(() => {
    if (!titleRef.current || typeof window === "undefined") {
      return;
    }
    const cssValue = getComputedStyle(document.documentElement)
      .getPropertyValue("--sticky-header-height")
      .trim();
    const offset = Number.parseFloat(cssValue || "0");
    const top = titleRef.current.getBoundingClientRect().top;
    setIsStuck(top <= offset + 1);
  }, [scrollY]);

  return (
    <section className={styles.section}>
      <div ref={titleRef} className={styles.title} data-stuck={isStuck}>
        <h2>
          {title}{" "}
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </h2>
      </div>
      <div className={styles.content}>{busy ? <Loader /> : children}</div>
    </section>
  );
};
